export default {
  getHelpMsgList: (state) => (updateDateTime) => {
    return state.helpInfoList.filter(helpInfo => {
      return parseInt(helpInfo.updateDateTime) === parseInt(updateDateTime)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/companiesCommonOptionModules/getters.js